// src/components/IntroBox.tsx
import React from 'react';
import { SBox, STitle, SsubTitle, Sitem, SuBox, SLabelTop } from './styles';
import Texts from '../Texts';
import IdentityFormBox from './IdentityFormBox';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface IntroBoxProps {
  mode?: string;
}

const IntroBox: React.FC<IntroBoxProps> = () => {
  // const navigate = useNavigate();
  // const { serverStepState } = useSelector(
  //   (state: RootState) => state.unifiedForm,
  // );

  // // مدیریت ناوبری پس از ارسال موفق فرم
  // const handleSubmitSuccess = () => {
  //   const stepMap: Record<string, string> = {
  //     IDENTITY_STEP_1: '/identify/step1',
  //     APP_STEP_1: '/application/step1',
  //     IDENTITY_STEP_2: '/identify/step2',
  //     APP_STEP_2: '/application/step2',
  //   };
  //   const nextRoute = stepMap[serverStepState || ''] || '/application';
  //   navigate(nextRoute, { state: { mode } });
  // };

  return (
    <SBox>
      <STitle>{Texts.intro.title}</STitle>
      <SsubTitle>{Texts.intro.subTitle}</SsubTitle>
      <Sitem>{Texts.intro.choosItem}</Sitem>
      <SuBox>
        <IdentityFormBox
          primary={Texts.intro.personalIdentty}
          secondary={Texts.intro.reality}
          backgroundColor={true}
          identityType="PERSONAL"
          // onSubmitSuccess={handleSubmitSuccess}
        />
        <IdentityFormBox
          primary={Texts.intro.companyIdentty}
          secondary={Texts.intro.legal}
          backgroundColor={false}
          identityType="LEGAL"
          // onSubmitSuccess={handleSubmitSuccess}
        />
      </SuBox>
      <SLabelTop>{Texts.intro.description}</SLabelTop>
    </SBox>
  );
};

export default IntroBox;
